/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import { observable } from 'mobx';

export default class RecommendedModel  {
	@observable state = 'pending';

	constructor() {
		this.recommendations = [];
		this.recommender = null;
		this.isNewLayoutEnabled = false;
	}
	getState() {
		return this.state;
	}
	getRecommendations() {
		return this.recommendations;
	}
	setState(state) {
		this.state = state;
	}
	setRecommender(recommender) {
		this.recommender = recommender;
	}
	setRecommendations(recommendations) {
		this.recommendations = recommendations;
	}
	getNewLayoutEnabled() {
		return this.isNewLayoutEnabled;
	}
	setNewLayoutEnabled(isEnabled) {
		this.isNewLayoutEnabled = isEnabled;
	}
	fetchRecommendations(widget, recommendationType) {
		this.state = 'pending';
		return this.recommender.fetchRecommendations(widget, recommendationType)
			.then(recommendations => {
				this.setRecommendations(recommendations);
				this.setState('done');
			})
			.catch((e) => {
				this.setState('error');
				throw e;
			});
	}

}



// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-recommender/src/js/RecommendedModel.js